var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.hash
      ? _c("iframe", {
          staticStyle: { width: "100%", height: "500px" },
          attrs: {
            src: `https://map.assistance10.com/address?&h=${_vm.hash}&o=${
              _vm.orderId ?? 0
            }&c=${_vm.cityId}&a=${_vm.address}`,
            frameborder: "0",
          },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }